import { events } from '@/services/wss/SystemEvents';
import ComponentNotifier from '@/services/wss/ComponentNotifier';
import WssEventHandlerBase from '@/services/engines/WssEventHandlerBase';
import outputMsgEngine from '@/Widgets/OutputMsgWidget/Core/OutputMsgEngine';
import { OpenToast } from '@/JxControls/JxToasts/StyledToast';

// output log category when the BE sends none
const DEFAULT_CATEGORY = 'Notification';

const _name = 'NotificationEngine';

class NotificationEngine extends WssEventHandlerBase {
    _name = _name;

    bootup() {
        super.bootup();
        this.clear();

        this._unsub = this._wsNotifier.subscribe(events.OnNotificationPublished, this.onMessage);
    }

    clear() {
        super.clear();

        if (this._unsub) this._unsub();
    }

    /**
     * Receives a pushed notification, already deserialized by WssEventNotifier.
     * @param {{traceId: string, receiver: string, message: string, data: string, targets: string, category: string, createdOn: number}} n
     */
    onMessage = (n) => {
        try {
            // receiver filter follows once the broadcast value is known
            this.logDebug('onMessage', JSON.stringify(n));

            // BE debug output / user messages: shared output log + toast
            outputMsgEngine.addMsg(n.category || DEFAULT_CATEGORY, 'log', n.message);
            OpenToast(n.message, 'info');

            ComponentNotifier.notify(_name, 'notificationReceived', n);
        } catch (error) {
            this.logError('onMessage', error.message);
        }
    };
}

const notificationEngine = new NotificationEngine();
export default notificationEngine;
